import { render, staticRenderFns } from "./UserBar.vue?vue&type=template&id=1a9c043d&"
import script from "./UserBar.vue?vue&type=script&lang=js&"
export * from "./UserBar.vue?vue&type=script&lang=js&"
import style0 from "./UserBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/m3/deti-ekarta43-ru/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {VAvatar,VBtn,VDivider,VFlex,VIcon,VList,VListTile,VListTileAction,VListTileContent,VListTileTitle,VMenu,VSubheader})
